import useSWR from "swr";
import LookupService from "services/lookup.service";

export function useDealProperties() {
  return useSWR("Lookup/dealProperties", async () => {
    const { response } = await LookupService.getDealPropertiesOptions();
    return response;
  });
}
